var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrophies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 363,
    height: 314,
    viewBox: "0 0 363 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.177 2C166.232 5.44127 134.467 4.17573 98.765 23.4711C91.7711 27.251 45.7532 57.3771 76.1141 76.5591C101.724 92.7393 161.858 85.5747 186.301 81.0421C207.602 77.092 255.975 61.698 241.041 46.004C235.177 39.842 219.905 37.3879 213.317 35.9763C196.143 32.2962 181.319 30.0866 163.768 27.6002C129.486 22.7436 95.2649 19.3881 60.7776 16.8646",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.596 170.809C61.6301 172.846 45.4544 161.041 24.4011 172.463C20.2769 174.7 -6.85987 192.533 11.0439 203.888C26.146 213.465 61.6071 209.224 76.0212 206.541C88.5825 204.203 117.108 195.091 108.301 185.801C104.843 182.153 95.8372 180.701 91.9524 179.865C81.8251 177.687 73.0835 176.379 62.7336 174.907C42.5174 172.032 22.3372 170.046 2 168.552",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M331.457 152.688C308.491 154.725 293.037 141.888 266.336 145.798C262.212 148.036 235.075 165.869 252.979 177.223C268.081 186.801 303.542 182.56 317.956 179.877C330.517 177.539 359.043 168.426 350.236 159.136C346.778 155.489 337.772 154.036 333.887 153.201C323.76 151.022 315.018 149.714 304.668 148.243C284.452 145.368 264.272 143.381 243.935 141.888",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0247 65.7051C68.0526 78.8788 68.5429 92.9079 74.1086 105.226C87.3912 134.624 103.965 144.962 134.157 154.067C168.26 164.352 200.112 162.62 210.368 126.579C214.111 113.423 223.476 94.9491 213.671 82.6932",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60156 197.474C6.39085 205.236 6.68056 213.503 9.96943 220.761C17.8184 238.083 27.6124 244.175 45.4531 249.54C65.6051 255.6 84.4273 254.58 90.4875 233.343C92.6996 225.591 98.2332 214.705 92.4394 207.484",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M246.536 170.809C248.325 178.571 248.615 186.838 251.904 194.096C259.753 211.418 269.547 217.51 287.388 222.875C307.54 228.935 326.362 227.915 332.422 206.678C334.634 198.926 340.168 188.04 334.374 180.819",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.918 102.378C128.918 109.359 130.945 116.332 133.017 123.29",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0217 218.936C42.3011 223.061 43.5979 227.181 44.9239 231.292",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M282.957 192.271C284.236 196.396 285.533 200.516 286.859 204.627",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M139.552 101.507C140.311 108.302 142.166 118.043 142.166 124.161",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1758 218.936C48.7423 222.837 50.1269 228.43 50.1269 231.943",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M290.11 192.271C290.677 196.172 292.061 201.765 292.061 205.278",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M119.948 110.22C129.248 109.642 138.523 109.254 147.83 108.913",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1196 223.488C42.543 223.201 47.9514 223.007 53.3787 222.838",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M279.054 196.823C284.478 196.535 289.886 196.342 295.313 196.173",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M111.67 120.676H148.701",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9167 229.992H54.0291",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M273.852 203.327H295.964",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M164.821 113.705C166.803 109.197 169.52 102.873 171.743 98.3111C172.367 97.0296 173.031 95.7656 173.752 94.5354C173.928 94.2352 174.565 92.7983 175.373 92.7444C176.03 92.7006 175.711 99.3115 175.712 99.4729C175.767 106.978 176.23 114.44 176.947 121.909C177.097 123.481 177.869 125.108 176.293 125.661C172.142 127.118 167.848 127.945 163.514 128.662C162.254 128.871 152.863 130.348 159.593 129.098C172.946 126.617 186.824 124.087 199.674 119.804",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M165.608 168.87C170.339 193.227 175.621 217.267 181.251 241.393",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7844 258.607C66.5378 272.805 69.6127 286.818 72.8895 300.881",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M305.719 231.943C308.473 246.141 311.548 260.154 314.824 274.217",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M161.342 221.485C155.628 224.487 148.561 225.733 144.199 230.491C141.956 232.938 141.493 238.227 143.962 240.445C153.731 249.223 189.569 255.831 198.789 257.193C218.526 260.109 269.428 260.575 257.328 244.711C249.015 233.813 232.345 227.268 219.882 223.381C199.409 216.997 178.261 215.02 157.076 212.953",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3579 289.586C57.9869 291.332 53.8179 292.057 51.2448 294.826C49.9218 296.249 49.6487 299.326 51.105 300.617C56.8678 305.723 78.0094 309.568 83.4482 310.36C95.0918 312.057 125.12 312.328 117.982 303.099C113.078 296.758 103.244 292.95 95.8915 290.689C83.8144 286.975 71.3387 285.825 58.8413 284.622",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M303.292 262.921C299.921 264.667 295.753 265.392 293.179 268.16C291.856 269.584 291.583 272.661 293.04 273.952C298.802 279.058 319.944 282.903 325.383 283.695C337.026 285.392 367.054 285.663 359.916 276.434C355.013 270.093 345.178 266.285 337.826 264.024C325.749 260.31 313.273 259.159 300.776 257.957",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2255 223.263C65.8516 222.095 70.3501 220.04 70.1589 225.969C69.9974 230.975 67.2573 235.928 63.3588 238.947C62.8773 239.32 60.5834 241.354 59.7394 240.081C58.5827 238.336 59.7999 235.852 61.3846 234.926C63.4723 233.705 66.2795 233.322 68.6417 233.591C72.1498 233.992 74.7054 236.385 78.0374 237.101C81.3058 237.804 83.3149 234.205 84.5999 231.818",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M307.114 193.52C310.34 191.669 314.564 190.798 317.059 194.495C318.436 196.536 315.729 198.599 314.16 199.344C311.809 200.46 309.212 200.62 306.672 200.306C303.888 199.963 306.379 199.585 307.686 199.552C309.987 199.495 314.535 199.38 316.084 201.528C317.297 203.211 316.11 205.572 314.446 206.325C313.214 206.883 306.852 208.58 307.816 205.688",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophies);
export default __webpack_public_path__ + "static/media/trophies.b2a91b7b230bf5e11a3418b35a570af3.svg";
export { ForwardRef as ReactComponent };